module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_a_positivo-e4d0292717ba230494a29eb62f1b6b2d.svg";